/**************************************************
 * Nombre:       Dialogo_Comanda
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {useEffect, useState} from "react";
import Formulario_Comanda from "../Formularios/Formulario_Comanda";
import Formulario_Comanda_Productos from "../Formularios/Formulario_Comanda_Productos";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {guardarDocs} from "../../Servicios/BD/guardarDocs";

const Dialogo_Comanda = ({datos, cerrar, realizado}) => {
    const [platosPedidos, setPlatosPedidos] = useState([]);
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos ? datos : {numHoras: 1}})
    const {props: propsPedidos, obtenerEntidad: obtenerPedidos} = useFormulario({valoresDefecto: {}})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })
    const [cambia, setCambia] = useState(false)

    const cambiar = () => {
        setCambia(!cambia)
    }

    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        if (!entidad.estado) {
            entidad.estado = 'En servicio'
        }

        iniciarCarga('Subiendo Datos')

        let dox = await guardarDoc('comandas', entidad)
        if (dox.res) {
            let platos = platosPedidos.map((it) => ({...it, idComanda: dox.data}))
            await guardarDocs({col: 'platosPedidos', arrObj: platos})
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }

    }

    const borrar = async () => {
        await borrarDoc('comandas', datos.id)
        terminar({aviso: 'Comanda borrada'})
    }

    useEffect(() => {

        if (datos.id) {
            let idComanda = datos.id
            if (idComanda) {
                let w = [where('idComanda', '==', idComanda)]
                obtenerColWheres({col: 'platosPedidos', wheres: w}).then((dox) => {
                    setPlatosPedidos(dox.data);
                })
            }
        }

    }, [datos, cambia])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Comanda props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                <Formulario_Comanda_Productos props={propsPedidos} platosPedidos={platosPedidos}
                                              setPlatosPedidos={setPlatosPedidos} realizado={cambiar}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Comanda